import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=b3d3b696&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d3b696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3d3b696')) {
      api.createRecord('b3d3b696', component.options)
    } else {
      api.reload('b3d3b696', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=b3d3b696&scoped=true&", function () {
      api.rerender('b3d3b696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mwj2zezmXecV/JS/comp/Accordion.vue"
export default component.exports